export const categoriesQueryKeys = {
    all: ['category'],
};